"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const reactstrap_1 = require("reactstrap");
const react_loops_1 = require("react-loops");
const AdminOnly_1 = require("./AdminOnly");
const react_2 = require("@osmosys/react");
const react_if_1 = require("react-if");
exports.NavPills = ({ center, tabs, queryDetailLayout = false, }) => {
    if (tabs.length === 0) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement(reactstrap_1.Nav, { pills: true, color: "dark", "data-in-qdv": !!queryDetailLayout, className: classnames_1.default({
            'justify-content-center': center,
        }) },
        react_1.default.createElement(react_loops_1.For, { of: tabs }, (t, { index }) => {
            return (react_1.default.createElement(NavPill, { key: index, queryDetailLayout: queryDetailLayout, meta: t }));
        })));
};
const NLink = (_a) => {
    var { children, meta } = _a, props = tslib_1.__rest(_a, ["children", "meta"]);
    return (react_1.default.createElement(reactstrap_1.NavLink, Object.assign({ to: meta.to, tag: react_router_dom_1.NavLink, "data-osmosys-comp": `nav-link.${meta.id}`, exact: typeof meta.exact === 'boolean' ? meta.exact : true }, props), children));
};
const NavPill = ({ meta, queryDetailLayout, }) => {
    const isVisible = react_1.useMemo(() => (meta.show ? meta.show() : true), [meta]);
    if (!isVisible) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const navItem = (react_1.default.createElement(reactstrap_1.NavItem, { className: meta.navItemClassName },
        react_1.default.createElement(NLink, { meta: meta, className: classnames_1.default({
                'py-1': queryDetailLayout,
            }, meta.className) },
            react_1.default.createElement(react_if_1.When, { condition: meta.adminRole === 'app' },
                react_1.default.createElement(react_2.OsmosysTooltip, { label: "App admins only", span: true },
                    react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "appAdminsOnly", marginRight: true }))),
            react_1.default.createElement(react_if_1.When, { condition: meta.adminRole === 'workspace' },
                react_1.default.createElement(react_2.OsmosysTooltip, { label: "Workspace admins only", span: true },
                    react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "workspaceAdminsOnly", marginRight: true }))),
            ' ',
            meta.name)));
    if (meta.adminRole === 'app') {
        return react_1.default.createElement(AdminOnly_1.AdminOnly, null, navItem);
    }
    if (meta.adminRole === 'workspace') {
        return react_1.default.createElement(AdminOnly_1.AdminOnly, { workspaceAdminsAlso: true }, navItem);
    }
    return navItem;
};
//# sourceMappingURL=NavPills.js.map